<template>
  <div class="text-center">
    <p class="login-warning">
      Log in or sign up to the Riverflex network platform using your LinkedIn
    </p>
    <button
      class="linked-in-btn d-flex align-center justify-center"
      @click="login"
    >
      <v-img
        :src="linkedInLogo"
        :max-width="linkedInLogoWidth"
        class="linked-in-logo"
      />
      <span class="linked-in-btn-text">Continue with LinkedIn</span>
    </button>
    <p class="login-rules">
      By signing up to our platform you agree to our T&Cs which can be found
      <a
        target="_blank"
        class="login-rules-link"
        href="https://riverflex.com/terms-and-conditions/"
      >here</a>.
    </p>
  </div>
</template>

<script lang="ts">
import { mapState } from 'vuex'
import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { trackSignInTap } from '@/segmentAnalytics/registration'

@Component
export default class LoginBtnWithRules extends Vue {
  linkedInLogo: string = require('@/assets/images/ui/bottom-nav/linked-in-logo.svg')

  get linkedInLogoWidth (): number {
    return this.$mediaQuery.isLargeDesktop ? 46 : 30
  }

  private login () {
    trackSignInTap()
    this.$emit('login')
  }
}
</script>
<style lang="scss" scoped>
.linked-in-btn {
  position: relative;
  width: 100%;
  height: 51px;
  border-radius: 8px;
  outline: none;
  border: 1px solid var(--v-lightGrey-base);
  background-color: var(--v-lightBeige-base);
  padding: 0 12px;
  cursor: pointer;
  .media-lg-desktop & {
    height: 66px;
  }
  &:hover {
    background-color: var(--v-beige-base);
  }
}
.linked-in-btn-text {
  font-size: 17px;
  .media-lg-desktop & {
    font-size: 26px;
    color: var(--v-darkPurple-base);
  }
}
.linked-in-logo {
  position: absolute;
  left: 14px;
}
.login-warning {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: var(--v-black-base);
  margin-bottom: 15px;
  margin-top: 0;
  .media-lg-desktop & {
    font-size: 26px;
    margin-bottom: 25px;
    letter-spacing: 0.3px;
  }
}
.login-rules {
  opacity: 0.8;
  font-size: 13px;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: center;
  color: var(--v-black-base);
  padding: 0px 20px;
  margin-top: 10px;
  margin-bottom: 0;
  .media-lg-desktop & {
    font-size: 21px;
    margin-top: 20px;
  }
}
.login-rules-link {
  font-weight: bold;
  color: var(--v-black-base);
}
</style>
